import { NavigationState } from '~/components/navigation/navigation-state';
import { NavigationMenuItem } from '~/components/navigation/navigation-types';
import { ClassicFormSettingsHolder } from '~/forms/classic-form-settings-holder';

/**
 * This class is to maintain the busines logic to enabling/disabled of the form controls for a particular
 * the classic form associated with a nav menu item.
 *
 * It is introduced to reduce the control related logic in the classic form.
 */
export class ClassicFormSettings {
	private formControls: ClassicFormSettingsHolder;

	constructor(
		private readonly originalFormControls: ClassicFormSettingsHolder,
		private readonly navState?: NavigationState,
	) {
		this.formControls = originalFormControls;
	}

	/**
	 * Build the granted permission based on menu items
	 * TODO: to move other logic from the classic form
	 * @param menuItems
	 */
	public applyBy(menuItems: NavigationMenuItem[]): void {
		// NOTE: `disableDelete` from menu item is only applied if the form supports `canDelete` control
		const canDelete =
			this.originalFormControls.canDelete &&
			!this.navState.computeDisableDeleteForm(menuItems);
		// TODO to implement the logic for other form control properties

		this.formControls = new ClassicFormSettingsHolder(
			this.originalFormControls.canAdd,
			this.originalFormControls.canSave,
			canDelete,
			this.originalFormControls.hasAuditDetails,
			this.originalFormControls.hasNotes,
		);
	}

	/**
	 * Check if the form control `canAdd` is enabled
	 */
	public canAdd(): boolean {
		return this.formControls.canAdd;
	}

	/**
	 * Check if the form control `canSave` is enabled
	 */
	public canSave(): boolean {
		return this.formControls.canSave;
	}

	/**
	 * Check if the form control `canDelete` is enabled
	 */
	public canDelete(): boolean {
		return this.formControls.canDelete;
	}

	/**
	 * Check if the form control `canAdd` is enabled
	 */
	public hasAuditDetails(): boolean {
		return this.formControls.hasAuditDetails;
	}

	/**
	 * Check if the form control `canAdd` is enabled
	 */
	public hasNotes(): boolean {
		return this.formControls.hasNotes;
	}
}
